import { useState } from 'react';

export function DebriefSection({ debrief = [], onUpdate }) {
  const [wentWell, setWentWell] = useState('');
  const [surpriseQuestions, setSurpriseQuestions] = useState('');
  const [followUp, setFollowUp] = useState('');
  const [interviewDate, setInterviewDate] = useState('');
  const [editingId, setEditingId] = useState(null);

  function addEntry() {
    if (!wentWell.trim() && !surpriseQuestions.trim() && !followUp.trim()) return;
    const entry = {
      id: crypto.randomUUID(),
      round: debrief.length + 1,
      interviewDate: interviewDate || null,
      wentWell: wentWell.trim(),
      surpriseQuestions: surpriseQuestions.trim(),
      followUp: followUp.trim(),
      createdAt: new Date().toISOString(),
    };
    onUpdate([...debrief, entry]);
    clearForm();
  }

  function startEdit(entry) {
    setEditingId(entry.id);
    setInterviewDate(entry.interviewDate || '');
    setWentWell(entry.wentWell || '');
    setSurpriseQuestions(entry.surpriseQuestions || '');
    setFollowUp(entry.followUp || '');
  }

  function saveEdit() {
    onUpdate(debrief.map((e) =>
      e.id === editingId
        ? { ...e, interviewDate: interviewDate || null, wentWell: wentWell.trim(), surpriseQuestions: surpriseQuestions.trim(), followUp: followUp.trim() }
        : e
    ));
    clearForm();
  }

  function cancelEdit() {
    clearForm();
  }

  function deleteEntry(id) {
    onUpdate(debrief.filter((e) => e.id !== id));
    if (editingId === id) clearForm();
  }

  function clearForm() {
    setEditingId(null);
    setInterviewDate('');
    setWentWell('');
    setSurpriseQuestions('');
    setFollowUp('');
  }

  return (
    <div className="space-y-3">
      <label className="text-xs font-medium text-slate-600">Interview Debrief</label>

      {debrief.length > 0 && (
        <div className="space-y-2">
          {[...debrief].reverse().map((entry) => (
            <div key={entry.id} className={`rounded border p-2 text-xs space-y-1 ${editingId === entry.id ? 'border-primary-300 bg-primary-50' : 'border-slate-200'}`}>
              <div className="flex items-center justify-between">
                <p className="font-medium text-slate-500">Round {entry.round} — {entry.interviewDate ? new Date(entry.interviewDate + 'T00:00:00').toLocaleDateString() : new Date(entry.createdAt).toLocaleDateString()}</p>
                <div className="flex gap-1">
                  <button
                    type="button"
                    onClick={() => startEdit(entry)}
                    className="text-slate-400 hover:text-primary-600 px-1"
                    title="Edit"
                  >
                    ✎
                  </button>
                  <button
                    type="button"
                    onClick={() => deleteEntry(entry.id)}
                    className="text-slate-400 hover:text-destructive-600 px-1"
                    title="Delete"
                  >
                    ×
                  </button>
                </div>
              </div>
              {entry.wentWell && <p><span className="text-green-600">✓</span> {entry.wentWell}</p>}
              {entry.surpriseQuestions && <p><span className="text-amber-600">?</span> {entry.surpriseQuestions}</p>}
              {entry.followUp && <p><span className="text-blue-600">→</span> {entry.followUp}</p>}
            </div>
          ))}
        </div>
      )}

      <div className="space-y-2 rounded border border-slate-200 p-2">
        <p className="text-xs font-medium text-slate-500">
          {editingId ? `Editing Round ${debrief.find((e) => e.id === editingId)?.round}` : `New Debrief (Round ${debrief.length + 1})`}
        </p>
        <input
          type="date"
          value={interviewDate}
          onChange={(e) => setInterviewDate(e.target.value)}
          className="w-full rounded border border-slate-300 px-2 py-1 text-base focus:outline-none focus:ring-1 focus:ring-primary-500"
        />
        <textarea
          value={wentWell}
          onChange={(e) => setWentWell(e.target.value)}
          placeholder="What went well?"
          rows={2}
          className="w-full rounded border border-slate-300 px-2 py-1 text-base focus:outline-none focus:ring-1 focus:ring-primary-500 resize-y"
        />
        <textarea
          value={surpriseQuestions}
          onChange={(e) => setSurpriseQuestions(e.target.value)}
          placeholder="What technical questions caught me off guard?"
          rows={2}
          className="w-full rounded border border-slate-300 px-2 py-1 text-base focus:outline-none focus:ring-1 focus:ring-primary-500 resize-y"
        />
        <textarea
          value={followUp}
          onChange={(e) => setFollowUp(e.target.value)}
          placeholder="What do I need to follow up on?"
          rows={2}
          className="w-full rounded border border-slate-300 px-2 py-1 text-base focus:outline-none focus:ring-1 focus:ring-primary-500 resize-y"
        />
        <div className="flex gap-2">
          {editingId ? (
            <>
              <button type="button" onClick={saveEdit} className="rounded bg-primary-600 px-2 py-1 text-xs text-white hover:bg-primary-700">Save Changes</button>
              <button type="button" onClick={cancelEdit} className="rounded bg-slate-100 px-2 py-1 text-xs hover:bg-slate-200">Cancel</button>
            </>
          ) : (
            <button type="button" onClick={addEntry} className="rounded bg-slate-100 px-2 py-1 text-xs hover:bg-slate-200">Save Debrief</button>
          )}
        </div>
      </div>
    </div>
  );
}
